import { render, staticRenderFns } from "./ScbEasy_backup_new.vue?vue&type=template&id=30010c08&scoped=true"
import script from "./ScbEasy_backup_new.vue?vue&type=script&lang=js"
export * from "./ScbEasy_backup_new.vue?vue&type=script&lang=js"
import style0 from "./ScbEasy_backup_new.vue?vue&type=style&index=0&id=30010c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30010c08",
  null
  
)

export default component.exports